export default {
  GET_PROFESSIONS_QUERY_SERVICE: Symbol.for('GET_PROFESSIONS_QUERY_SERVICE'),
  PROFESSION_REPOSITORY: Symbol.for('PROFESSION_REPOSITORY'),
  ONBOARDING_CATALOGS_PROFESSION_STATE_MANAGER:
    Symbol.for('ONBOARDING_CATALOGS_PROFESSION_STATE_MANAGER'),
};
